import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { request } from '../../../../services/request';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import {
  Namespace,
  ChatMode,
} from '@wix/ambassador-legends-persona-v1-chat/types';
import { createPersonaChat } from '@wix/ambassador-legends-persona-v1-chat/http';

export default async function (
  flowAPI: ControllerFlowAPI,
  personaId: string,
  firstMessage: string,
) {
  try {
    const chatId = (
      await request({
        flowAPI,
        options: createPersonaChat({
          chat: {
            personaId,
            namespace: Namespace.EDUCATION,
            mode: ChatMode.PREVIEW,
          },
          firstMessage,
        }),
        errorOptions: {
          errorCodesMap: { applicationError: {} },
        },
      })
    )?.data?.chat?.id;

    flowAPI.controllerConfig.setProps({
      currentChatId: chatId,
    });
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'CreatePersonaChat',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });
  }
}
